export default __webpack_public_path__ + "static/media/header.522305c6.jpeg";